/// <reference path="../modules/blocks.storage.module.ts" />
/// <reference path="../objects/classes/storagebase.ts" />

module Blocks {
    export class LocalStorage extends App.Classes.StorageBase implements App.Interfaces.IStorageBase {
        static factoryId: string = "localStorageFactory";

        constructor() {
            super(localStorage);
        }
    }
    
    Blocks.storage.factory(LocalStorage.factoryId, [() => new LocalStorage()]);
}